import { ProfileModel } from './profile.model';

/* eslint-disable @typescript-eslint/naming-convention */
export interface ChatHeader {
    id: number;
    hotel_id: number;
    profile_id: number;
    profile_name: string;
    room_no: string;
    name: string;
    description: string;
    badge: number;
    count: number;
    send_time: number;
    last_time: string;
    image_url: string;
}

export class ChatLogModel {
    id: number;
    hotel_id: number;
    request_header_id: number;
    user_type: string;
    user_id: number;
    user_name: string;
    avatar_url: string;
    message_type: string;
    message: string;
    read: boolean;
    read_at: Date;
    created_at: Date;
    record_type: 'HotSupport' | '';

    constructor(
        request_header_id: number,
        message: string,
        profile: ProfileModel
    ) {
        this.id = 0;
        this.hotel_id = profile.hotel_id;
        this.request_header_id = request_header_id;
        this.user_type = 'profil';
        this.user_id = profile.id;
        this.user_name = `${profile.first_name} ${profile.last_name}`;
        this.avatar_url = profile.profile_pic_url;
        this.message_type = 'Message';
        this.message = message;
        this.read = false;
        this.read_at = new Date();
        this.created_at = new Date();
    }
}
